import { module as m } from 'modujs';
import {StoreSingleton} from "../../../singletons/store";

export default class extends m {
    constructor(m) {
        super(m);

        // VAR
        this.dom = {};
        this.dom.openOverlayCps = this.el.querySelectorAll('#home [data-overlay-name], #single-communique [data-overlay-name]');
    }

    /**
     * INIT
     */
    init() {

        for(let i = 0; i < this.dom.openOverlayCps.length; i++) {
            this.dom.openOverlayCps[i].addEventListener('click', (e) => {
                e.preventDefault();
                const link = this.dom.openOverlayCps[i].querySelector('a').getAttribute('href');
                this.call('show', {link: link}, 'Legal', this.dom.openOverlayCps[i].dataset.overlayName);
            })

            if( this.dom.openOverlayCps[i].dataset.autostart ) {
                const link = this.dom.openOverlayCps[i].querySelector('a').getAttribute('href');
                this.call('show', {link: link}, 'Legal', this.dom.openOverlayCps[i].dataset.overlayName);
            }

        }

        const _event = new Event('siteIsReady');
        this.el.dispatchEvent(_event);
    }

    /**
     * START
     */
    start() {}

    /**
     * DESTROY
     */
    destroy() {}
}
